import React from 'react';
import { useCinemaTheme } from '../../contexts/CinemaThemeContext';
import { GRAIN_SVG_URL } from '../../utils/cinemaThemes';

const baseStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  zIndex: 2,
};

const GRAIN_OPACITY = 0.14;
const VIGNETTE_OPACITY = 0.62;
const LUMIERE_OPACITY = 0.13;

const CinemaBackground: React.FC = () => {
  const { cinemaTheme } = useCinemaTheme();

  if (cinemaTheme === 'none') return null;

  if (cinemaTheme === 'lumiere') {
    return (
      <div style={{
        ...baseStyle,
        background: `radial-gradient(ellipse 75% 55% at 50% -5%, rgba(255,252,215,${LUMIERE_OPACITY}) 0%, transparent 70%)`,
      }} />
    );
  }  

  if (cinemaTheme === 'celluloid') {
    return (
      <>
        <div style={{
          ...baseStyle,
          opacity: GRAIN_OPACITY,
          backgroundImage: `url("${GRAIN_SVG_URL}")`,
          backgroundRepeat: 'repeat',
          backgroundSize: '160px 160px',
        }} />
        <div style={{
          ...baseStyle,
          background: `radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,${VIGNETTE_OPACITY}) 100%)`,
        }} />
      </>
    );
  }

  return null;
};

export default CinemaBackground;
